import {
    FETCH_JOB,
    RESET_JOB,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
  };
  
  const jobViewReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_JOB:
        return { data: action.payload };
      case RESET_JOB:
        return initialState;
      default:
        return state;
    }
  };
  
  export default jobViewReducer;
  